import React from 'react';
import PropTypes from 'prop-types';

import { FormInput as FormInputElem } from './Contact.styles';

const Input = React.forwardRef(({ type, name, required, label }, ref) => (
  <>
    <FormInputElem
      id={name}
      type={type}
      name={name}
      className="border-primary rounded-none h-8 border-b-2 block w-full focus:outline-none"
      aria-label={label}
      aria-required={required}
      placeholder=" "
      ref={ref}
    />
    <label
      className="absolute top-0 left-0 pointer-events-none transition-all duration-150 text-basic-500"
      htmlFor={name}
    >
      {label} {required && '*'}
    </label>
  </>
));

Input.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  required: PropTypes.bool,
  label: PropTypes.string.isRequired,
};

Input.defaultProps = {
  type: 'text',
  required: false,
};

export default Input;
